import React, { useEffect, useMemo, useState } from "react";
import "./Sidebar.scss";
import { getSidebarDataForUser } from "./sidebarData/SideabrData.js";
import { useNavigate, useLocation } from "react-router-dom";
import Avatar from "react-avatar";
import { Sidebar, Menu, SubMenu } from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import ConfirmationModal from "../modal/ConfirmationModal.jsx";
import { removeCookies } from "../../../services/Cookies.js";
import { setloggedIn } from "../../../store/Slices/userSlice.js";
import {
  fetchPermissions,
  clearPermissions,
} from "../../../store/Slices/permissionSlice.js";
import {
  LogoutApi,
  ClearNotificationApi,
  GetNotificationApi,
} from "../../../api/request/users";
import Bellicon from "../../../assets/Bellicon.jsx";
import { Drawer, Badge } from "antd";
import Profile from "../../../pages/profile/Profile.jsx";
import Notifications from "../notifications/Notifications.jsx";
import * as signalR from "@microsoft/signalr";
import { Cookies } from "react-cookie";
import { IpProvider } from "../../../services/IpProvider.js";
import useCan from "../../../hooks/useCan.jsx";

export default function UserSidebar() {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const { token } = cookies.getAll();
  const userDetails = useSelector((state) => state.user.userDetails);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
  const [isNotification, setIsNotification] = useState(false);
  const [notifications, setNotifications] = useState({
    isReadCount: 0,
    unReadCount: 0,
    totalMessageCount: 0,
    details: [],
  });
  const [isfetchNotification, setIsFetchNotification] = useState(false);
  const [connection, setConnection] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const can = useCan();

  const isFullAdmin =
    userDetails?.roleName?.toLowerCase() === "admin" ||
    userDetails?.roleId == 1;

  function initializeSignalRConnection() {
    try {
      if (!connection) {
        const newConnection = new signalR.HubConnectionBuilder()
          .withUrl(process.env.REACT_APP_CHAT_HUB_URL, {
            accessTokenFactory: () => token,
          })
          .withAutomaticReconnect()
          .build();

        setConnection(newConnection);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (isfetchNotification) {
      initializeSignalRConnection();
    }
  }, [isfetchNotification]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {})
        .catch((err) => console.error(err.toString()));

      connection.on("ReceiveMessage", (data) => {
        setNotifications((prevState) => ({
          ...prevState,
          isReadCount: prevState.isReadCount,
          unReadCount: prevState.unReadCount + 1,
          totalMessageCount: prevState.totalMessageCount + 1,
          details: prevState?.details?.length
            ? [...prevState?.details, data]
            : [data],
        }));
      });
    }
  }, [connection]);

  const getNotification = async () => {
    try {
      const { data } = await GetNotificationApi();
      if (data?.success) {
        setNotifications(data?.data);
      }
      setIsFetchNotification(true);
    } catch (error) {
      setIsFetchNotification(true);
    }
  };

  const getIpAddress = async () => {
    try {
      const ipResponse = await IpProvider();
      const data = ipResponse?.data;
      if (data?.ip) {
        setIpAddress(data.ip);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getNotification();
    getIpAddress();
  }, []);

  const handleMenuClick = (index) => {
    setOpenSubMenuIndex(index);
  };

  function getFirstPath(path) {
    const parts = path.split("/");
    return parts.length > 1 ? "/" + parts[1] : path;
  }

  const isActivePath = (path) => {
    let active = false;
    path?.map((item) => {
      if (item == getFirstPath(pathname)) {
        active = true;
      }
    });
    return active;
  };

  const logoutHandler = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi({ ipAddress });
      if (data?.success) {
        toast.success(data?.message);
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      dispatch(clearPermissions());
      removeCookies("token");
      navigate("/");
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      dispatch(clearPermissions());
      removeCookies("token");
      navigate("/");
      setIsLoading(false);
    }
  };

  const clearNotifications = async () => {
    try {
      const { data } = await ClearNotificationApi();
      if (data.success) {
        setNotifications([]);
        toast.success(data.message);
      }
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  };

  useEffect(() => {
    if (userDetails?.userId && !isFullAdmin) {
      dispatch(fetchPermissions(userDetails.userId));
    }
  }, [userDetails?.userId]);

  const sidebarForUser = useMemo(
    () => getSidebarDataForUser(userDetails?.department),
    [userDetails?.department],
  );

  const filteredSidebar = sidebarForUser.map((item) => {
    if (!item.children) {
      if (!can(item.module, item.action, item?.subModule)) return null;
      return item;
    }
    const visibleChildren = item.children.filter((child) =>
      can(child.module, child.action, child?.subModule),
    );
    if (visibleChildren.length === 0) return null;
    return { ...item, children: visibleChildren };
  }).filter(Boolean);

  return (
    <div className="sidebar-container w-[250px] fixed">
      <div className="h-[75px] border-b border-gray-200 p-4">
        <div className="h-full w-full flex items-center justify-between">
          <img className="h-[44px]" src="/assets/logo/logo.png" alt="logo" />
          <div
            className="cursor-pointer"
            onClick={() => setIsNotification(true)}
          >
            <Badge count={notifications?.unReadCount || 0} overflowCount={5}>
              <Bellicon />
            </Badge>
          </div>
        </div>
      </div>

      <div className="h-[calc(100vh-150px)] overflow-y-auto pl-4">
        {filteredSidebar.map((item, index) => {
          const iconWithProps = React.cloneElement(item?.icon, {
            active: isActivePath(item?.activeUrl),
          });
          return item?.children ? (
            <Sidebar>
              <Menu>
                <SubMenu
                  key={index}
                  open={openSubMenuIndex == index}
                  onOpenChange={() =>
                    handleMenuClick(index == openSubMenuIndex ? null : index)
                  }
                  label={
                    <div
                      key={index}
                      className={`flex items-center text-[#2F2B3DB2] font-medium cursor-pointer py-2 px-6 header`}
                    >
                      {item?.icon}
                      <p className="text-base ms-3">{item?.title}</p>
                    </div>
                  }
                >
                  <div className="pt-1">
                    {item?.children?.map((childItem, index) => {
                      const childIconWithProps = React.cloneElement(
                        childItem?.icon,
                        { active: isActivePath(childItem?.activeUrl) },
                      );
                      return (
                        <div
                          key={index}
                          onClick={() => navigate(childItem?.url)}
                          className={` submenu child flex items-center text-[#2F2B3DB2] cursor-pointer font-medium py-2 ms-5 ps-4 pe-6 mr-4 duration-200 ${index != 0 ? "mt-1" : null} ${isActivePath(childItem?.activeUrl) ? "active_icon primary text-white rounded-lg font-semibold" : null}`}
                        >
                          {childIconWithProps}
                          <p className="ms-2">{childItem?.title}</p>
                        </div>
                      );
                    })}
                  </div>
                </SubMenu>
              </Menu>
            </Sidebar>
          ) : (
            <div
              key={index}
              onClick={() => {
                navigate(item?.url);
                handleMenuClick(index);
              }}
              className={` header flex items-center text-[#2F2B3DB2] font-medium cursor-pointer my-3 py-2 px-6 mr-4 duration-200 ${isActivePath(item?.activeUrl) ? "bg-primary text-white rounded-lg font-semibold" : null}`}
            >
              {/* <img src={item?.icon} alt='icon' className='mr-4 h-[24px] w-[24px]' /> */}
              {iconWithProps}
              <p className="text-base ms-2">{item?.title}</p>
            </div>
          );
        })}
      </div>

      <div className="h-[75px] p-4">
        <div className="flex items-center justify-between gap-5 cursor-pointer">
          <div
            className="flex items-center gap-3"
            onClick={(e) => setIsDrawerOpen(true)}
          >
            <Avatar
              size={46}
              src={userDetails.profileImage}
              className="rounded-full"
            />
            <div>
              <p className="font-semibold text-base line-clamp-1">
                {userDetails.fullName}
              </p>
              {/* <p className='text-sm primary'>{userDetails.roleName}</p> */}
            </div>
          </div>
          <button className="text-red-600" onClick={() => setIsModalOpen(true)}>
            <img src="/assets/icons/_logout.svg" className="h-5" alt="icon" />
            {/* <p>Logout</p> */}
          </button>
        </div>
      </div>

      {/* --- Loguot confirmation modal --- */}
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        message="Are you sure you want to logout?"
        onConfirm={logoutHandler}
        isLoading={isLoading}
        loadingLabel="Loging out..."
      />

      {/* --- admin profile drawer --- */}
      <Drawer
        title={
          <div className="flex justify-between items-center">
            <p>Profile</p>
            <button
              className="text-sm text-red-600 font-semibold px-6 py-2 flex items-center gap-3"
              onClick={() => setIsModalOpen(true)}
            >
              <img src="/assets/icons/_logout.svg" className="h-5" alt="icon" />
              <p>Logout</p>
            </button>
          </div>
        }
        onClose={(e) => setIsDrawerOpen(false)}
        width={600}
        open={isDrawerOpen}
      >
        <Profile isAdmin={isFullAdmin} />
      </Drawer>

      {/* --- Notification drawer --- */}
      <Drawer
        title={
          <div className="flex justify-between items-center">
            <p>Notification</p>
            <p className="cursor-pointer" onClick={clearNotifications}>
              Clear all
            </p>
          </div>
        }
        onClose={(e) => setIsNotification(false)}
        width={600}
        open={isNotification}
      >
        <Notifications notifications={notifications} />
      </Drawer>
    </div>
  );
}
